import React, { useState, useContext, useEffect } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import EmailVerificationForm from './EmailVerificationForm';
import PasswordRecoverForm from './PasswordRecoverForm';

export const AUTH_ZONE = {
    LOGIN: 0,
    REGISTER: 1,
    EMAIL_VERIFICATION: 2,
    PASSWORD_RESET: 3
};

const AuthForms = ({ onFinishCallback, onAuthZoneChanged }) => {

    const [zone, setZone] = useState(AUTH_ZONE.LOGIN);

    function changeZone( newZone ){
        onAuthZoneChanged?.( newZone );
        setZone( newZone );
    }

    function getFooterNav() {

        switch( zone ){

            case AUTH_ZONE.PASSWORD_RESET:
            case AUTH_ZONE.REGISTER:
                return <button
                                onClick={() => {
                                    changeZone( AUTH_ZONE.LOGIN );
                                }} className='helperLink left'>
                                Go back to <span>Login</span>
                            </button>
            case AUTH_ZONE.EMAIL_VERIFICATION:
                return <button
                                onClick={onFinishCallback} className='helperLink left'>
                                I'll do it later
                            </button >
            default: 
                return <></>
        };

    }

    function getZoneWidget() {
        switch (zone) {
            case AUTH_ZONE.REGISTER:
                return <RegisterForm onFinishCallback={onFinishCallback}/>;
            case AUTH_ZONE.EMAIL_VERIFICATION:
                return <EmailVerificationForm onFinishCallback={onFinishCallback}/>
            case AUTH_ZONE.PASSWORD_RESET:
                return <PasswordRecoverForm onFinishCallback={onFinishCallback}/>
            default:
            case AUTH_ZONE.LOGIN:
                return <LoginForm onFinishCallback={onFinishCallback} requestZoneChange={changeZone}/>;
        }
    }

    return (
        <>
            {getZoneWidget()}
            <div className={'forms_footer'}>
                {getFooterNav()}
            </div>
        </>
    );
};

export default AuthForms;
